let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bNRlW")).then(() => parcelRequire('kUWXo'));